import { AddressStatusEnum, CountryCode, DimensionUnitEnum, UnitOfMeasureEnum, WeightUnitEnum } from "../../../api/Representation";
import { DeliveryExpediencyEnum } from "../../vehicleRates/api/Representation";
import { DebtorInvoiceChargeTypeEnum } from "../../debtors/api/Representation";
export var CreationSourceEnum;
(function (CreationSourceEnum) {
    CreationSourceEnum["CONSIGNMENT_API"] = "CONSIGNMENT_API";
    CreationSourceEnum["SALES_ORDER_API"] = "SALES_ORDER_API";
    CreationSourceEnum["RETAIL_EXPRESS_API"] = "RETAIL_EXPRESS_API";
    CreationSourceEnum["ADMIN"] = "ADMIN";
    CreationSourceEnum["IMPORT"] = "IMPORT";
    CreationSourceEnum["SCHEDULER"] = "SCHEDULER";
    CreationSourceEnum["CONSUMER_APP"] = "CONSUMER_APP";
    CreationSourceEnum["SHOPIFY"] = "SHOPIFY";
    CreationSourceEnum["SUBTRUX_SALES_ORDER"] = "SUBTRUX_SALES_ORDER";
})(CreationSourceEnum || (CreationSourceEnum = {}));
export var ConsignmentStatusEnum;
(function (ConsignmentStatusEnum) {
    ConsignmentStatusEnum["UNASSIGNED"] = "UNASSIGNED";
    ConsignmentStatusEnum["SCHEDULED"] = "SCHEDULED";
    ConsignmentStatusEnum["ON_ROUTE"] = "ON_ROUTE";
    ConsignmentStatusEnum["PICKED_UP"] = "PICKED_UP";
    ConsignmentStatusEnum["AT_DC"] = "AT_DC";
    ConsignmentStatusEnum["ASSIGNED"] = "ASSIGNED";
    ConsignmentStatusEnum["STARTED"] = "STARTED";
    ConsignmentStatusEnum["COMPLETED"] = "COMPLETED";
    ConsignmentStatusEnum["CANCELLED"] = "CANCELLED";
})(ConsignmentStatusEnum || (ConsignmentStatusEnum = {}));
export var CommunicationChannelEnum;
(function (CommunicationChannelEnum) {
    CommunicationChannelEnum["APP"] = "APP";
    CommunicationChannelEnum["SMS"] = "SMS";
    CommunicationChannelEnum["EMAIL"] = "EMAIL";
})(CommunicationChannelEnum || (CommunicationChannelEnum = {}));
export var ConsignmentActionEnum;
(function (ConsignmentActionEnum) {
    ConsignmentActionEnum["PICKUP"] = "PICKUP";
    ConsignmentActionEnum["DELIVER"] = "DELIVER";
})(ConsignmentActionEnum || (ConsignmentActionEnum = {}));
export var ActionStatusEnum;
(function (ActionStatusEnum) {
    ActionStatusEnum["SCHEDULED"] = "SCHEDULED";
    ActionStatusEnum["ON_ROUTE"] = "ON_ROUTE";
    ActionStatusEnum["PICKED_UP"] = "PICKED_UP";
    ActionStatusEnum["ASSIGNED"] = "ASSIGNED";
    ActionStatusEnum["STARTED"] = "STARTED";
    ActionStatusEnum["COMPLETED"] = "COMPLETED";
})(ActionStatusEnum || (ActionStatusEnum = {}));
export var ConsignmentImageKindEnum;
(function (ConsignmentImageKindEnum) {
    ConsignmentImageKindEnum["PICK_UP_DOCKET"] = "PICK_UP_DOCKET";
    ConsignmentImageKindEnum["COMPLETION_PHOTO"] = "COMPLETION_PHOTO";
    ConsignmentImageKindEnum["OTHER_PHOTO"] = "OTHER_PHOTO";
})(ConsignmentImageKindEnum || (ConsignmentImageKindEnum = {}));
export var ConsignmentOrderByEnum;
(function (ConsignmentOrderByEnum) {
    ConsignmentOrderByEnum["DELIVERY_FROM_ASC"] = "DELIVERY_FROM_ASC";
    ConsignmentOrderByEnum["DELIVERY_FROM_DESC"] = "DELIVERY_FROM_DESC";
    ConsignmentOrderByEnum["COMPLETED_AT_DESC"] = "COMPLETED_AT_DESC";
    ConsignmentOrderByEnum["REFERENCE_ASC"] = "REFERENCE_ASC";
    ConsignmentOrderByEnum["MODIFIED_AT_DESC"] = "MODIFIED_AT_DESC";
})(ConsignmentOrderByEnum || (ConsignmentOrderByEnum = {}));
export var CustomerAPIConsignmentStatusEnum;
(function (CustomerAPIConsignmentStatusEnum) {
    CustomerAPIConsignmentStatusEnum["SCHEDULED"] = "SCHEDULED";
    CustomerAPIConsignmentStatusEnum["TO_BE_RESCHEDULED"] = "TO_BE_RESCHEDULED";
    CustomerAPIConsignmentStatusEnum["IN_TRANSIT"] = "IN_TRANSIT";
    CustomerAPIConsignmentStatusEnum["ARRIVED"] = "ARRIVED";
    CustomerAPIConsignmentStatusEnum["ON_ROUTE"] = "ON_ROUTE";
    CustomerAPIConsignmentStatusEnum["ON_ITS_WAY"] = "ON_ITS_WAY";
    CustomerAPIConsignmentStatusEnum["COMPLETED"] = "COMPLETED";
})(CustomerAPIConsignmentStatusEnum || (CustomerAPIConsignmentStatusEnum = {}));
export var MarketplaceConsignmentPaymentMethodEnum;
(function (MarketplaceConsignmentPaymentMethodEnum) {
    MarketplaceConsignmentPaymentMethodEnum["DELIVERY"] = "DELIVERY";
    MarketplaceConsignmentPaymentMethodEnum["TONNE"] = "TONNE";
})(MarketplaceConsignmentPaymentMethodEnum || (MarketplaceConsignmentPaymentMethodEnum = {}));
var WouldRecommendEnum;
(function (WouldRecommendEnum) {
    WouldRecommendEnum["DEFINITELY"] = "DEFINITELY";
    WouldRecommendEnum["MAYBE"] = "MAYBE";
    WouldRecommendEnum["NOT_SURE"] = "NOT_SURE";
    WouldRecommendEnum["PROBABLY_NOT"] = "PROBABLY_NOT";
    WouldRecommendEnum["NO_CHANCE"] = "NO_CHANCE";
})(WouldRecommendEnum || (WouldRecommendEnum = {}));
export class ConsignmentFreightRequestTransformer {
    static fromResponse(response) {
        return {
            version: response.version,
            productId: response.productId,
            productReference: response.productReference,
            productDescription: response.productDescription,
            description: response.description,
            trackingCode: response.trackingCode,
            wasteRecordId: response.wasteRecordId,
            height: response.height,
            width: response.width,
            length: response.length,
            dimensionUnit: response.dimensionUnit,
            weight: response.weight,
            weightUnit: response.weightUnit,
            unitOfMeasure: response.unitOfMeasure,
            netUnitOfMeasure: response.netUnitOfMeasure,
            orderedQuantity: response.orderedQuantity,
            grossQuantity: response.grossQuantity,
            tareQuantity: response.tareQuantity,
            netQuantity: response.netQuantity,
        };
    }
}
